import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase-Konfiguration (Environment Variables mit Fallback für lokale Entwicklung)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBF5RlcQrQu5E7K8goGEcnEyy37je4UihM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "curiculumner.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "curiculumner",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "curiculumner.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "610801436731",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:610801436731:web:a5ee1cdcb6fd2defbb741e",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-NW8YNG5SPK"
};


// Firebase initialisieren
const app = initializeApp(firebaseConfig);

// Auth und Firestore exportieren
export const auth = getAuth(app);
export const db = getFirestore(app);

console.log('Firebase initialisiert mit Project ID:', firebaseConfig.projectId); 